var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorYoutubeIcon = function SvgColorYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.333 12c0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12s-5.372 12-12 12c-6.627 0-12-5.373-12-12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.466 9.036a1.63 1.63 0 0 0-1.132-1.162c-.998-.274-5-.274-5-.274s-4.003 0-5.001.274c-.551.151-.985.597-1.132 1.162-.267 1.025-.267 3.164-.267 3.164s0 2.138.267 3.163c.147.566.581 1.01 1.132 1.162.998.275 5 .275 5 .275s4.003 0 5.001-.275c.551-.151.985-.596 1.132-1.162.268-1.025.268-3.163.268-3.163s0-2.139-.268-3.164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M11.134 14.4v-4l3.2 2z"
  })));
};
export default SvgColorYoutubeIcon;